/**
 * Product filter object
*/
const ProductFilter = function ProductFilter(productFilterFieldName, productFilterValues, productPlaceholder) {
  return {
    field_name: productFilterFieldName || 'productFilters',
    field_value: '', // TODO: Use config values
    rules: [],
    field_type: 'select',
    label: 'Choose as many as you would like from this list.',
    help_text: 'You can select many choices here #4.',
    values: productFilterValues || [],
    is_required: false,
    is_enabled: true,
    visible: true,
    placeholder: productPlaceholder,
    sub_text: null,
  };
};
/**
 * export service to used by different components
 */
export default ProductFilter;



// WEBPACK FOOTER //
// ./src/services/ProductFilter.js